// Load all the controllers within this directory and all subdirectories
// Controller files must be named *_controller.js

import { application } from "./application"

import BlastRadiusController from "./blast_radius_controller"
import ChatController from "./chat_controller"
import CollapsibleController from "./collapsible_controller"
import DiscoveryProgressController from "./discovery_progress_controller"
import DisclosureController from "./disclosure_controller"
import DropdownController from "./dropdown_controller"
import ReactFlowController from "./react_flow_controller"
import TabsController from "./tabs_controller"
import ThemeController from "./theme_controller"
import IssueGridController from "./issue_grid_controller"

application.register("blast-radius", BlastRadiusController)
application.register("chat", ChatController)
application.register("collapsible", CollapsibleController)
application.register("discovery-progress", DiscoveryProgressController)
application.register("disclosure", DisclosureController)
application.register("dropdown", DropdownController)
application.register("react-flow", ReactFlowController)
application.register("tabs", TabsController)
application.register("theme", ThemeController)
application.register("issue-grid", IssueGridController)

export { application }
